<script lang="ts">
	import type { Device } from 'src/types/Device';
	import { firmwares_gen_2 } from 'src/stores/device-runtime/process';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { getDeviceState } from 'src/stores/device-runtime/states';
	import { devices_config } from 'src/configs/devices';
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_control_component_channel_structure,
		is_gen_2,
		real_id,
	} from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';
	import { roller_is_calibrated } from 'src/helpers/requests/calibrate_cover';
	import ControlDirectionDevicePageV2 from 'src/components/Controls/Single/ControlDirectionDevicePageV2.svelte';
	import ControlDirectionDevicePageG2V2 from 'src/components/Controls/Single/ControlDirectionDevicePageG2V2.svelte';
	import ControlPositionG2V2 from 'src/components/Controls/Single/ControlPositionG2V2.svelte';
	import ControlPositionV2 from 'src/components/Controls/Single/ControlPositionV2.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import DeviceLabelList from '../DeviceLabelList.svelte';
	import TimerRemaining from 'src/components/TimerRemaining/TimerRemaining.svelte';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;
	$: isGen2 = is_gen_2(device);
	$: deviceState = getDeviceState(device?.id);

	$: rollerCalibrated = roller_is_calibrated(device, status, settings);
	$: rollerLostPosition =
		status?.[get_gen_2_component_channel_structure(device)]?.current_pos === null;
	$: positioningControl =
		!isGen2 && device?.category === 'roller'
			? status?.rollers?.[device?.channel]?.positioning
			: true;

	$: _statusesRaw =
		status?.online && devices_config?.[device?.type]
			? status_configurator(status, device, settings)
			: [];
	$: _statuses = Array.isArray(_statusesRaw) ? _statusesRaw : [];
	$: labelList = _statuses.filter((e) => typeof e.main === 'undefined' && e.name !== 'state');

	let timerLabels: Record<string, any> = {};
	$: timer =
		isGen2 &&
		status?.online &&
		!!devices_config?.[device?.type] &&
		typeof status?.[get_gen_2_component_channel_structure(device)]?.timer_started_at !== 'undefined';
	$: combinedLabelList = [...Object.values(timerLabels), ...labelList];
</script>

<DeviceViewStateWrapper {device}>
	<div slot="staticTop">
		{#if timer}
			{#key status[get_gen_2_control_component_channel_structure(device)].timer_started_at}
				<TimerRemaining timerKey="gen2_main" {device} {status} {settings} bind:timerLabels />
			{/key}
		{/if}
		<DeviceLabelList labelList={combinedLabelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div class="flex-full-height justify-content-end" slot="content">
		{#if rollerCalibrated && !rollerLostPosition && positioningControl}
			{#if isGen2}
				<ControlPositionG2V2 {device} {status} {settings} />
			{:else}
				<ControlPositionV2 {device} {status} {settings} />
			{/if}
		{/if}
	</div>
	<div class="justify-content-end" slot="staticBottom">
		{#if isGen2}
			<ControlDirectionDevicePageG2V2 {device} {status} />
		{:else}
			<ControlDirectionDevicePageV2 {device} {status} />
		{/if}
	</div>
</DeviceViewStateWrapper>
